import React from "react";
import { Link } from "react-router-dom";
import { Facebook, Phone, Mail, MapPin } from "lucide-react";

export default function Footer({ content }) {
  const contact = content?.contact || {};
  const year = new Date().getFullYear();
  return (
    <footer className="relative z-10 section-dark pt-16 pb-8" data-testid="footer">
      <div className="mx-auto max-w-7xl px-6">
        <div className="grid gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <img src="/brand/logo-badge.png" alt="Keys Event Center" className="h-36 mb-4 object-contain" />
            <p className="text-white/60 max-w-sm text-sm leading-relaxed">
              A brand-new private indoor family entertainment venue in Keys / Park Hill, Oklahoma.
              Book the whole place. Play, party, celebrate.
            </p>
            <a href={contact.facebook || "#"} target="_blank" rel="noreferrer"
              className="inline-flex items-center gap-2 mt-5 btn-ghost-light px-4 py-2 text-sm" data-testid="footer-facebook">
              <Facebook size={16} /> Follow on Facebook
            </a>
          </div>
          <div>
            <h4 className="font-display font-bold text-white mb-4">Explore</h4>
            <ul className="space-y-2 text-sm text-white/60">
              <li><Link to="/whats-included" className="hover:text-white transition-colors">What's Included</Link></li>
              <li><Link to="/events" className="hover:text-white transition-colors">Events</Link></li>
              {content?.settings?.gallery_enabled !== false && <li><Link to="/gallery" className="hover:text-white transition-colors">Gallery</Link></li>}
              <li><Link to="/about" className="hover:text-white transition-colors">About</Link></li>
              <li><Link to="/reservations" className="hover:text-white transition-colors">Reserve</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-display font-bold text-white mb-4">Get In Touch</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li className="flex items-center gap-2"><Phone size={15} className="text-[#f6b64a]" /> {contact.phone}</li>
              <li className="flex items-center gap-2"><Mail size={15} className="text-[#f6b64a]" /> {contact.email}</li>
              <li><a href="https://www.google.com/maps/search/?api=1&query=26505+S+520+Rd+Park+Hill+OK+74451" target="_blank" rel="noreferrer" className="flex items-center gap-2 hover:text-white transition-colors" data-testid="footer-address-link"><MapPin size={15} className="text-[#f6b64a]" /> {contact.address}</a></li>
            </ul>
          </div>
        </div>
        <div className="h-px bg-white/10 my-8" />
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-white/45">
          <span>© {year} Keys Event Center. All rights reserved. · <Link to="/privacy" className="underline hover:text-white/80" data-testid="footer-privacy-link">Privacy & Policies</Link></span>
          <a href="https://www.builtby-ab.com" target="_blank" rel="noreferrer" className="hover:text-white/80 transition-colors" data-testid="built-by-ab">Built by AB</a>
        </div>
      </div>
    </footer>
  );
}
